export default __webpack_public_path__ + "static/media/unselected1.807e041c.png";